<template>
  <refonte-modal
    v-bind:show="props.show"
    v-on:close="props.on_close"
    v-bind:title="title"
    class="!max-w-[720px]">
    <template v-slot:modalBody>
      <div
        class="flex flex-col gap-[8px] pb-[12px]"
        v-if="!loading">
        <div v-if="props.description">
          {{ props.description }}
        </div>
        <div
          v-for="(section, sectionIndex) in sections"
          v-bind:key="`section-${sectionIndex}`"
          class="flex flex-col gap-[8px] pb-[8px]">
          <template v-if="section">
            <refonte-label
              v-if="section.title"
              class="gap-[8px]"
              v-bind:label="section.title"
              v-bind:label_icon="section.icon" />
            <div
              v-for="(file, fileIndex) in computeList(section.files)"
              v-bind:key="`file-${fileIndex}`"
              class="flex flex-wrap gap-[8px]">
              <refonte-item-file-convention-line
                v-bind:signature_manuelle="
                  props.signature_manuelle_convention_id != undefined
                "
                v-bind:open_signature_manuelle="
                  () =>
                    props.open_signature_manuelle &&
                    props.open_signature_manuelle(file.id)
                "
                v-bind:id="`convention-${fileIndex}`"
                v-bind:title="file.title"
                v-bind:subtitle="file.subtitle"
                v-bind:convention="file"
                v-bind:on_close="props.on_close"
                v-bind:on_submit="props.on_submit"
                v-bind:participant_nom_prenom="props.participant_nom_prenom"
                v-bind:session_date="props.session_date"
                v-bind:formation_title="file.produitTitre"
                v-bind:client_id="props.client_id" />
            </div>
            <RefonteSeparator
              v-if="sectionIndex !== sections.length - 1"
              class="pt-[12px]" />
          </template>
        </div>
      </div>
      <spinner
        sizes="w-20 h-20"
        thickness="border-8"
        v-else />
    </template>
  </refonte-modal>
</template>

<script setup lang="ts">
  import RefonteModal from '@/components/refonte/modals/refonte-modal.vue';
  import RefonteLabel from '@/components/refonte/inputs/refonte-label.vue';
  import RefonteSeparator from '@/components/refonte/separators/refonte-separator.vue';
  import Spinner from '@/components/utils/spinner.vue';
  import { InterlocuteurSignataire } from '@/types/gestion/interlocuteurs-types';
  import RefonteItemFileConventionLine from '@/components/refonte/items/refonte-item-file-convention-line.vue';
  import { ConventionDocument } from '@/types/gestion/inscriptions-types';
  import { computed } from 'vue';

  const props = withDefaults(
    defineProps<{
      show: boolean;
      on_close: Function;
      on_submit?: Function;
      title?: string;
      sections: {
        title?: string;
        icon?: Element;
        files: ConventionDocument[];
      };
      file_on_click_download?: Function;
      participant_nom_prenom?: string;
      session_date?: string;
      signataire_list?: InterlocuteurSignataire[];
      class?: string;
      loading?: boolean;
      description?: string;
      client_id?: number;
      open_signature_manuelle?: Function;
      signature_manuelle_convention_id?: string;
    }>(),
    {
      title: 'Document',
      file_signed_label: 'Signée',
      class: ''
    }
  );

  const sections = computed(() =>
    props.sections.filter((s) => computeList(s.files).length > 0)
  );
  const computeList = (list) =>
    props.signature_manuelle_convention_id != undefined
      ? list.filter(
          (f) => f.id.toString() == props.signature_manuelle_convention_id
        )
      : list;
</script>

<style lang="scss" scoped></style>
